import { jsxs as d, jsx as s } from "react/jsx-runtime";
import { useState as m, useEffect as b } from "react";
import { withManagedProps as u } from "@made-people/managed-props";
import { z as a } from "zod";
import { withZod as x } from "@made-people/react-prop-guard";
import { motion as n } from "motion/react";
import { linksHoverImageBlueprint as I } from "./index-blueprint.es.js";
import { responsiveImageSchema as p, ResponsiveImage as c } from "@made-people/blueprint-responsive-image";
import { linkAsLinkSchema as A, LinkAsLink as N } from "@made-people/blueprint-link";
import { componentWrapperSchema as w, ComponentWrapper as S } from "@made-people/blueprint-component-wrapper";
import "@made-people/blueprint";
const j = a.object({
  layout: w.shape.layout.optional(),
  imageSettings: p.optional(),
  content: a.object({
    heading: a.string().optional().describe("The heading of the category links"),
    categories: a.object({
      link: a.object({
        target: a.string().optional(),
        href: a.string()
      }),
      linkLabel: a.string().optional(),
      image: p
    }).array().min(1)
  }),
  linkSettings: A.optional(),
  variants: a.custom().optional()
}), R = n(c), v = {
  "card-intitial": (i) => ({
    rotate: 0,
    filter: "blur(1px)",
    zIndex: i.isActive ? 20 : 20 - i.index,
    transition: { duration: 0.3 }
  }),
  "card-animate": (i) => ({
    rotate: i.index % 2 === 0 ? -(i.index + 2) : i.index + 2,
    filter: i.isActive ? "blur(0px)" : "blur(1px)",
    zIndex: i.isActive ? 20 : 20 - i.index,
    transition: {
      duration: i.isLoaded ? 0.3 : 0.35,
      delay: i.isLoaded ? 0 : 2 + i.index * 0.1
    }
  }),
  standard: (i) => ({
    opacity: i.isActive ? 1 : 0,
    zIndex: i.isActive ? 20 : 0,
    rotate: 0,
    filter: "blur(0px)",
    transition: { duration: 0.3 }
  })
}, T = u(
  "LinksHoverImages",
  x(
    j,
    ({ variants: i, content: e, layout: g, linkSettings: h, imageSettings: k }) => {
      const [f, y] = m(!1), [L, l] = m(0);
      b(() => {
        y(!0);
      }, []);
      const t = I.styles(i);
      return /* @__PURE__ */ d(S, { layout: g, className: t.base, children: [
        /* @__PURE__ */ d(
          "div",
          {
            className: t.linksWrapper,
            onMouseLeave: () => l(0),
            children: [
              e.heading && /* @__PURE__ */ s(
                n.h3,
                {
                  initial: { opacity: 0, y: 30 },
                  animate: { opacity: 1, y: 0 },
                  transition: { duration: 0.3 },
                  className: t.title,
                  children: e.heading
                }
              ),
              e == null ? void 0 : e.categories.map((r, o) => /* @__PURE__ */ s(
                n.span,
                {
                  initial: { opacity: 0, y: 30, filter: "blur(2px)" },
                  whileInView: { opacity: 1, y: 0, filter: "blur(0px)" },
                  transition: { duration: 0.3, delay: 0.1 * o },
                  viewport: { once: !0 },
                  onMouseEnter: () => l(o),
                  onFocus: () => l(o),
                  className: t.link,
                  children: /* @__PURE__ */ s(
                    N,
                    {
                      ...r.link,
                      link: r.link,
                      label: r.linkLabel,
                      className: t.link,
                      ...h
                    }
                  )
                },
                `${r.linkLabel}-${o}`
              ))
            ]
          }
        ),
        /* @__PURE__ */ s(
          n.div,
          {
            className: t.images,
            transition: { delay: 0.15 },
            initial: {
              opacity: (i == null ? void 0 : i.imageLayout) === "stacked-cards" ? 1 : 0
            },
            animate: { opacity: 1 },
            children: e == null ? void 0 : e.categories.map((r, o) => /* @__PURE__ */ s(
              n.div,
              {
                className: t.imageWrapper,
                variants: v,
                custom: {
                  index: o,
                  isActive: L === o,
                  total: e.categories.length,
                  isLoaded: f
                },
                whileInView: (i == null ? void 0 : i.imageLayout) === "stacked-cards" ? "card-animate" : "standard",
                initial: (i == null ? void 0 : i.imageLayout) === "stacked-cards" ? "card-initial" : "standard",
                children: /* @__PURE__ */ s(
                  c,
                  {
                    ...k,
                    ...r.image,
                    className: t.image
                  }
                )
              },
              `${r.linkLabel}-${o}`
            ))
          }
        )
      ] });
    }
  )
);
export {
  T as LinksHoverImages,
  j as LinksHoverImagesPropsSchema,
  R as MotionImage
};
//# sourceMappingURL=index.es.js.map
